module.exports = __webpack_public_path__ + "img/woman-head-front.ff5fcae9.png";